/**
 * Padrao do NOME e da RAZAO SOCIAL do cadastro de clientes (pedido do Ruan, 03/10/2026):
 * **maiusculo, sem acento e sem Ç**. `"João  Pedro Dutra"` -> `"JOAO PEDRO DUTRA"`.
 *
 * ⛔ **Peca UNICA, aplicada no SERVIDOR** — toda porta que grava cliente passa por aqui
 * (cadastro, edicao e a ficha que a captura do balcao cria pelo telefone). Antes a regra
 * morava so na tela de Clientes, e o balcao gravava o nome como veio: 113 de 422 fichas
 * estavam fora do padrao quando isto nasceu.
 *
 * O Ç sai junto com o acento: no `normalize('NFD')` ele vira `C` + cedilha (U+0327),
 * que esta na faixa dos sinais combinantes. Tambem apara e colapsa espacos.
 */

/** Os sinais combinantes do Unicode (U+0300..U+036F). Montado por escape, mesma tecnica
 *  do `marca-loja.ts`, pra o fonte nao depender de ser lido como UTF-8. */
const RE_ACENTO = new RegExp(`[${String.fromCharCode(0x0300)}-${String.fromCharCode(0x036f)}]`, 'g');

export function nomeCadastroCliente(valor: string): string {
  return nomeClienteAoDigitar(valor).replace(/\s+/g, ' ').trim();
}

/**
 * O mesmo padrao, pra campo que converte A CADA TECLA: nao apara espaco, senao o espaco
 * entre duas palavras some no instante em que e' digitado. O valor final ainda passa pelo
 * `nomeCadastroCliente` no servidor.
 */
export function nomeClienteAoDigitar(valor: string): string {
  return valor.normalize('NFD').replace(RE_ACENTO, '').toUpperCase();
}
